import { UserSelectRoles, UserGroupType } from '@/contexts/shared/users/Users.interfaces'

export const USER_SELECT_ROLES = {
  ...UserSelectRoles,
}

export const USER_GROUP_TYPE = {
  ...UserGroupType,
}
